var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoundOn = function SvgSoundOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sound-on_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 15.111 14.222-8.889v35.556L16 32.888V15.112ZM5.333 32.89h7.111V15.11H5.333V32.89Zm36.025-23.58-2.661 2.66C41.98 15.14 44 19.36 44 24c0 4.64-2.018 8.86-5.303 12.028l2.663 2.663C45.458 34.864 48 29.705 48 24s-2.542-10.862-6.642-14.692ZM40.488 24c0-3.705-1.626-7.052-4.238-9.584l-2.672 2.672c1.798 1.865 2.91 4.268 2.91 6.912 0 2.645-1.107 5.05-2.904 6.917l2.672 2.672c2.61-2.531 4.233-5.882 4.233-9.589Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sound-on_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.333 2.667H48v42.667H5.333z"
  })))));
};
export default SvgSoundOn;